module.exports = __webpack_public_path__ + "media/images/categories/feeling-248b007b61a94ccf0b8f3005509e2759.png";